import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Backup/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import BackupTable from 'components/Web_User_Interface/1440p_Series/System/Backup/backupTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menu // Software Backup",
  "path": "/Web_User_Interface/1440p_Series/System/Backup/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Backup your system settings.",
  "image": ".WebUI_1440p_SearchThumb_System_Backup.png",
  "social": "/images/SearchWebUI_1440p_SearchThumb_System_Backup.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const EuiSpacer = makeShortcode("EuiSpacer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title='System Menu // Software Backup' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Backup your system settings.' image='/images/SearchWebUI_1440p_SearchThumb_System_Backup.png' twitter='/images/SearchWebUI_1440p_SearchThumb_System_Backup.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Web_User_Interface/1440p_Serie/System/Backup/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Backup/' crumbLabel="Backup" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-series-2k-1440p--4k-2160p-web-user-interface",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-series-2k-1440p--4k-2160p-web-user-interface",
        "aria-label": "ultrahd series 2k 1440p  4k 2160p web user interface permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Series (2K+ 1440p & 4K 2160p) Web User Interface`}</h1>
    <h2 {...{
      "id": "system-menu",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-menu",
        "aria-label": "system menu permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menu`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/899a4e218307a80c5fa0977e8d0243e1/024d6/1440p_Settings_System_Backup.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACQklEQVQoz22S20sUYRiH98+IEiPM3Tmt6y5G7nFmZ3fcw7jzzc5hd9sSIUIIKa0sCbWDhRTShVAQmKHl0kVXXRUF4l3QTfQXPeFQItTFw++9+Pjx8L1vLJlMomlJZClOJlfFXtpl6tYuUws7mDfeoM9vY8xvR3lyri3uIJbfMd2bY+j0Kc4MDTE8PExMVVVUVUNKjDKRr3J5bZ9LawP6Dwb0Vgd0Vvb/IVx5z+WHA2bXP2C5MyiShKqOoSgaMUVROEKWZdKpMXynQSga+E49IhCNY8KIJh3bptOcxm82MA2TUrGCoVvkc/pfQzUqzGQyeGGHoNsj6HSPaXs+rufT9gKE3ybz6ALylsrFpSzNqo1hlCkVTbKTxROFksR4Ok3fcZh1HPpC4Hseoefht9sRQZQu9kyT+tU6dt/Gd2tYFSOyzGX/Uxi2HLrT01GGQtAR4ji7QtBzXXoiIBQhHS+k37WwKnpkmM+dKFRkCS2VYfOmy8EzwWClRRh4uH6A3xa051YR93ZpXX/OumHxqljmdsWi5VSpGjqWaVAsFIgd/V20GFlG1TQsI0+rmsOtm9hNG6dlU6/VCIKQpaU7LK89ZWtjg7cvNtl7vM7dKwFlvYhllsnnCsSkaOUqiqpyNI+cH+XsuRFS4xMYeoVK2aRWtXhyf4GPey/5enjIzx8HfP/8iV/fvvB68RrNahG9VCaX/WOoadrx6SiKHNkmEgkSCYl4PEE6laRSylHM59H1EhW9gJHPYpoGkxMpkkoiehePx/kNFvh6tsa1xEIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/899a4e218307a80c5fa0977e8d0243e1/e4706/1440p_Settings_System_Backup.avif 230w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/d1af7/1440p_Settings_System_Backup.avif 460w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/7f308/1440p_Settings_System_Backup.avif 920w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/7733b/1440p_Settings_System_Backup.avif 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/899a4e218307a80c5fa0977e8d0243e1/a0b58/1440p_Settings_System_Backup.webp 230w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/bc10c/1440p_Settings_System_Backup.webp 460w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/966d8/1440p_Settings_System_Backup.webp 920w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/85db8/1440p_Settings_System_Backup.webp 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/899a4e218307a80c5fa0977e8d0243e1/81c8e/1440p_Settings_System_Backup.png 230w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/08a84/1440p_Settings_System_Backup.png 460w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/c0255/1440p_Settings_System_Backup.png 920w", "/en/static/899a4e218307a80c5fa0977e8d0243e1/024d6/1440p_Settings_System_Backup.png 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/899a4e218307a80c5fa0977e8d0243e1/c0255/1440p_Settings_System_Backup.png",
              "alt": "Web User Interface - 1440p Series - System Backup",
              "title": "Web User Interface - 1440p Series - System Backup",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <BackupTable mdxType="BackupTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      